'use client';

import { PropsWithChildren } from 'react';

import { cn } from '../../utils/css/cn';

export type TagType = 'primary' | 'secondary' | 'light-grey' | 'secondary-light';

const TagTypeClassName: Record<TagType, Record<string, string>> = {
	primary: {
		default: 'bg-takeda-dark-red-600 text-white',
		hover: 'cursor-pointer hover:bg-takeda-dark-red-700',
	},
	secondary: {
		default: 'bg-gray-200 text-black',
		hover: 'cursor-pointer hover:bg-gray-300',
	},
	'light-grey': {
		default: 'bg-takeda-light-grey-600 text-black',
		hover: 'cursor-pointer hover:bg-gray-300',
	},
	'secondary-light': {
		default: 'bg-white text-black',
		hover: 'cursor-pointer hover:bg-gray-300',
	},
};

export interface TagProps extends PropsWithChildren {
	type?: TagType;
	className?: string;
	onClick?: () => void;
}

export const Tag = ({ type = 'primary', className, onClick, children }: TagProps) => {
	const tagClassName = cn(
		'inline-flex items-center break-normal py-1 px-4 rounded-2xl',
		className,
		TagTypeClassName[type].default,
		onClick ? TagTypeClassName[type].hover : undefined,
	);

	if (onClick) {
		return (
			<button className={tagClassName} onClick={onClick}>
				{children}
			</button>
		);
	}

	return <div className={tagClassName}>{children}</div>;
};
